import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { UiV2Scope } from '@kawai/ui';
import { AuthGuard } from './components/AuthGuard.js';
import { Layout } from './components/Layout.js';
import { RequireFeature } from './components/RequireFeature.js';
import DwPricePage from './pages/DwPricePage.js';
import { FuelPricesPage } from './pages/FuelPricesPage.js';
import { FuelSettingsPage } from './pages/FuelSettingsPage.js';
import PriceListPage from './pages/PriceListPage.js';
import { SignInPage } from './pages/SignInPage.js';
import { ROUTES } from './routes.js';

/**
 * F-02 / F-11: tenant-fuel app の root route。
 *
 * - `/signin`             : SignInPage
 * - `/`                    : AuthGuard + RequireFeature('fuel') + Layout / FuelPricesPage
 * - `/settings`            : 同上 / FuelSettingsPage（F-16: 区分・価格設定）
 * - `/dw-price` `/price-list` : Layout chrome なし（印刷ページのため独立）
 * - その他                 : `/` へ redirect
 *
 * S-136: Layout（AppShell の <main>）の内側を `UiV2Scope` で包み、書体・字間・行間（`.ui-v2`）と
 * @kawai/ui の Button / Input / Modal の v2 既定をページ本体へ。左・上部メニューは対象外。
 * 印刷ページ（/dw-price /price-list）は印刷物の書体・字間を変えないため包まない。
 */
function V2Scope() {
  return (
    <UiV2Scope>
      <Outlet />
    </UiV2Scope>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.signIn} element={<SignInPage />} />

        {/* メイン管理画面（Layout 経由 / sidebar + header あり） */}
        <Route
          element={
            <AuthGuard>
              <RequireFeature feature="fuel">
                <Layout />
              </RequireFeature>
            </AuthGuard>
          }
        >
          <Route element={<V2Scope />}>
            <Route index element={<FuelPricesPage />} />
            <Route path={ROUTES.settings} element={<FuelSettingsPage />} />
          </Route>
        </Route>

        {/* F-11: 印刷ページ（Layout chrome なし / 認証と feature ガードのみ） */}
        <Route
          element={
            <AuthGuard>
              <RequireFeature feature="fuel">
                <Outlet />
              </RequireFeature>
            </AuthGuard>
          }
        >
          <Route path={ROUTES.dwPrice} element={<DwPricePage />} />
          <Route path={ROUTES.priceList} element={<PriceListPage />} />
        </Route>

        <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
      </Routes>
    </BrowserRouter>
  );
}
